<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-22 11:20:09
 * @LastEditTime: 2021-07-22 15:44:44
 * @LastEditors: chenguobiao
-->
<template>
  <transition name="dialog">
    <div
      class="dialog"
      v-if="visible"
      :style="frameStyle"
    >
      <!-- title -->
      <p class="dialog-title">{{ title }}</p>
      <!-- 关闭按钮 -->
      <img
        v-if="showClose"
        class="dialog-close cursor-pointer"
        src="@/render/assets/images/home/dialog_close.png"
        alt="close"
        @click="onClose"
      />
      <!-- 主体内容 -->
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: Object, // { width: string, height: string }
    }
  },
  data() {
    return {}
  },
  components: {},
  computed: {
    frameStyle() {
      if (!this.size) return {}
      return { width: this.size.width, height: this.size.height }
    },
  },
  watch: {
    visible(flg) {
      if (!flg) this.onClose()
    },
  },
  async mounted() {},
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: val(600);
  min-height: val(320);
  background: #FFFDF9;
  border: 1px solid #6A492F;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  opacity: 1;
  border-radius: val(8);
  overflow: hidden;
  z-index: 999;
  &-close {
    position: absolute;
    top: val(23);
    right: val(23);
    width: val(14);
    height: val(14);
  }
  &-title {
    margin: -1px -1px 0;
    height: val(60);
    line-height: val(60);
    padding-left: val(18);
    background: url('../../../assets/images/home/dialog_header.png') no-repeat left top;
    background-size: 100% 100%;
    font-size: val(24);
    font-weight: bold;
    color: #3E2C00;
  }
}

.dialog-enter-active,
.dialog-leave-active {
  transition: all 0.3s;
}
.dialog-enter, .dialog-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
}
</style>
